import Pako from 'pako'

import { PlaceV0 } from '../data/model'

export function serializeCompactV0(place: PlaceV0): string {
  const serialize = JSON.stringify(place)
  const compressed = Pako.deflate(serialize)
  return uint8ToBase64(compressed)
}

function uint8ToBase64(arr: Uint8Array): string {
  return window.btoa(
    Array(arr.length)
      .fill('')
      .map((_, i) => String.fromCharCode(arr[i]))
      .join('')
  )
}
